import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NavArea, NavAreaWarning, NavAreaWarningApiQuery } from '@navfleet/client/map/safety/domain/models';
import { environment } from '@navfleet/shared/core/environment';

const NAV_AREA_URL = `${environment.NAVFLEET_BACKEND}/api/v1/data-layers/nav-areas`;
const NAV_AREA_WARNINGS_URL = `${NAV_AREA_URL}/warnings`;

@Injectable({
    providedIn: 'root',
})
export class MapSafetyNavAreaApi {
    private readonly http = inject(HttpClient);

    public getNavAreas() {
        return this.http.get<NavArea[]>(NAV_AREA_URL, {
            responseType: 'json',
        });
    }

    public getNavAreaWarnings(query: NavAreaWarningApiQuery) {
        return this.http.post<NavAreaWarning[]>(NAV_AREA_WARNINGS_URL, query);
    }
}
